<template>
  <div>

    <!--    <ValidationObserver ref="form">-->
    <form @submit.prevent="handleSubmit">
      <div class="grid">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p class="text-uppercase"><strong>{{ $t('SubidaArchivos') }}</strong></p>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-2 mt-3">
              <!--                <ValidationProvider name="apellidos" rules="required" v-slot="{ errors }">-->
              <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
              <!--                  <p class="text-danger" >{{ errors[0] }}</p>-->
              <!--                </ValidationProvider>-->
            </vx-input-group>
          </div>
          <div class="vx-col w-full text-right mb-3">
            <vs-button
              color="primary"
              type="border"
              @click="submitFiles()"
              size="small"
            >
              {{ $t('Guardar') }}
            </vs-button>
          </div>
        </div>
      </div>
    </form>
    <!--    </ValidationObserver>-->


    <!--    <div class="container">
          <div class="large-12 medium-12 small-12 cell">
            <label>Files
              <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
            </label>
            <button v-on:click="submitFiles()">Submit</button>
          </div>
        </div>-->
<!--    <div class="dz-preview dz-error dz-complete dz-image-preview">-->
<!--      <div class="dz-image">-->
<!--        <img data-dz-thumbnail="" alt="arzo-arsalan-BlWH1Lm7BpI-unsplash.jpg"-->
<!--      </div>-->
<!--      <div class="dz-details">-->
<!--        <div class="dz-size"><span data-dz-size="">/div>-->
<!--        <div class="dz-filename"><span data-dz-name=""></span></div>-->
<!--      </div>-->
<!--      <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress=""></span></div>-->
<!--      <div class="dz-error-message"><span-->
<!--        data-dz-errormessage="">File is too big (2.69MiB). Max filesize: 0.5MiB.</span></div>-->
<!--      <div class="dz-success-mark"></div>-->
<!--      <div class="dz-error-mark"></div>-->
<!--      <a class="dz-remove" href="javascript:undefined;" data-dz-remove="">Remove file</a></div>-->
  </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import axios from 'axios'
  import {config} from '../shared/app.config'


  export default {
    name: 'AtachmentView',
    components: {
      vueDropzone: vue2Dropzone
    },
    created () {

    },
    data () {
      return {
        file: '',
        template: `
            <div class="dz-preview dz-file-preview">
              <div class="dz-details">
                <div class="dz-filename"><span data-dz-name></span></div>
                <div class="dz-size" data-dz-size></div>
                <img data-dz-thumbnail />
              </div>
              <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
              <div class="dz-success-mark"><span>✔</span></div>
              <div class="dz-error-mark"><span>✘</span></div>
              <div class="dz-error-message"><span data-dz-errormessage></span></div>
            </div>
        `,
        // https://www.dropzonejs.com/#configuration-options
        dropzoneOptions: {
          url: 'https://httpbin.org/post',
          paramName: 'myFile',
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          acceptedFiles: 'image/*,application/pdf,.psd',
          //headers: {"My-Awesome-Header": "header value"},
          dictDefaultMessage: 'Drop files here to upload',
          wasQueueAutoProcess: false,
          autoQueue: false,
          addRemoveLinks: true,
          dictRemoveFile: 'Remove file',
          //previewTemplate: this.template
        }
      }
    },
      computed: {
      }
    ,
      methods: {
        hasFilesRejected () {
          return this.$refs.myVueDropzone.getRejectedFiles().length > 0;
        }
      ,
        submitFiles () {
          //let files = this.files;
          const rejectedFiles = this.$refs.myVueDropzone.getRejectedFiles();

          if (this.hasFilesRejected()) {
            console.log('FILES REJECT', rejectedFiles);
          }

          const formData = this.getFormData();
          //'https://httpbin.org/post'
          axios.post(`${config.webApiBase}/app/attachment`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(function () {
            console.log('SUCCESS!!');
          })
            .catch(function () {
              console.log('FAILURE!!');
            });
        }
      ,
        getFormData () {
          const formData = new FormData();
          const files = this.$refs.myVueDropzone.getAcceptedFiles();

          for (let i = 0; i < files.length; i++) {
            const file = files[i];

            formData.append(`myFile[${  i  }]`, file);
          }

          return formData;
        }
      ,
        // handleFilesUpload() {
        //   this.files = this.$refs.files.files;
        // }
      }

    }

</script>

<style>
  .vue-dropzone > .dz-preview .dz-remove {
    position: absolute;
    z-index: 31;
    color: #fff;
    top: inherit;
    bottom: 15px;
    text-decoration: none;
    text-transform: uppercase;
    font-size: .8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
  }
</style>
